import Wrapper from 'ui-components/Wrapper';
import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';
// ==============================|| LOADER ||============================== //
const BackrrLoadingAnimation = () => {
  const theme = useTheme();
  const matchesDownMd = useMediaQuery(theme.breakpoints.down('md'));
  return (
    // <Modal open={true}>
    <Wrapper className="skeleton" style={{
      display: 'grid',
      height: '100dvh',
      width: matchesDownMd ? "100vw" : "100vw",
      placeItems: 'center',
      position: 'fixed',
      top: "0px",
      left: "0rem",
      right: 0,
      bottom: 0,
      borderRadius: matchesDownMd ? "0px 0px 0px" : "0px 0px 0px"
    }}>
      {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
    </Wrapper>
    // </Modal>
  )
};

export default BackrrLoadingAnimation;